import { startSubmit, stopSubmit } from 'redux-form';
import { fetchAction } from 'barnyard/utils/';
import * as types from '../constants';

export const vendorFetch = () => dispatch => fetchAction(
  dispatch,
  types.VENDOR_FETCH,
  {},
  {
    url: '/api/vendors/vendor/',
    redirectToSignin: false
  }
);

export const vendorUpdate = values => dispatch => fetchAction(
  dispatch,
  types.VENDOR_UPDATE,
  {},
  {
    url: '/api/vendors/vendor/',
    method: 'PATCH',
    body: values,
    postBefore: () => {
      dispatch(startSubmit(types.VENDOR_MERCHANT_UPDATE_FORM));
    },
    postSuccess: () => {
      dispatch(stopSubmit(types.VENDOR_MERCHANT_UPDATE_FORM));
    },
    postFailure: (error) => {
      dispatch(stopSubmit(types.VENDOR_MERCHANT_UPDATE_FORM, {
        _error: {
          title: error.detail || 'Error Updating Information',
          details: `
Please correct the form and try again.
If this issue continues, contact us via the chat icon in the bottom right.`
        },
        ...error
      }));
    }
  }
);
